import { render } from "./NotifUnsubscribe.vue?vue&type=template&id=6b6aae08"
import script from "./NotifUnsubscribe.vue?vue&type=script&lang=ts"
export * from "./NotifUnsubscribe.vue?vue&type=script&lang=ts"
script.render = render

export default script